/*
 * @Descripttion:
 * @version:
 * @Author: geory
 * @Date: 2023-09-01 15:50:46
 * @LastEditors: geory
 * @LastEditTime: 2026-01-29 15:20:12
 */
import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import config from "./config/config";

const WLogin = () => import("./components/WLogin");
const WHome = () => import("./components/WHome");

const wminputManager = [
  {
    path: "/wlogin",
    name: "wlogin",
    component: WLogin,
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/whome",
    name: "whome",
    component: WHome,
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/",
    redirect: "/whome",
  },
];

const routerParams = {
  routes: wminputManager,
};

const router = new VueRouter(routerParams);

//router.beforeEach()
export default router;
